/**
 * Blue-purple gradient used throughout the Guide Assistant UI.
 * Matches the design system's Gradient/Blue-Purple token.
 */
export const bluePurpleGradient = (opacity: number) =>
  `linear-gradient(99deg, rgba(0, 116, 221, ${opacity}) -2.93%, rgba(89, 30, 255, ${opacity}) 58.85%, rgba(150, 68, 255, ${opacity}) 126.18%)`;
